import React from 'react';
const OrderItemSubtext = ({ text }) => React.createElement("p", { className: 'font-italic text-xs' }, text);
export default OrderItemSubtext;
